import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, useParams } from "react-router-dom";

import Grid from '@mui/material/Grid2';

import { 
  Campaign,
  CampaignPlayer, 
} from "@dndModels";

import API from "@dndUtilities/system_api";

import LoadingBox from "@components/input/LoadingBox";
import CenteredMenu from "@components/input/menus/CenteredMenu";
import ButtonBox from "@components/input/buttons/ButtonBox";

import CommonUtilities from "@utilities/common_utilities";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function CampaignJoin() {
  const { id, invite } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [obj, setObj] = useState<Campaign>(new Campaign());
  const [mode, setMode] = useState("Characters");

  const load = useCallback( async () => {
    // debugger;
    if (id !== undefined && invite !== undefined && obj._id !== id) {
      const res = await api.getCampaign({ campaign_id: id, include: ["players","characters"] });
      if (res) {
        if (res.reusable_invite === invite || res.invites.includes(invite)) {
          setObj(res);
          setLoading(false);
        } else {
          setNavigateTo("/");
        }
      } else {
        setNavigateTo("/");
      }
    } else {
      setNavigateTo("/");
    }
  }, []);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setLoading(true);
      setTimeout(() => {
        load();
      }, 100);
    }
  }, [fetched]);

  const render_tab = () => {
    let return_me = <Grid>Coming Soon</Grid>;
    if (mode === "Players") {
      return_me = (
        <Grid container spacing={0} direction="row">
          { obj.players.map(player => {
            return (
              <Grid size={4} key={player._id}>
                { player.use_name }
              </Grid>
            );
          })}
        </Grid>
      ); 
    } else if (mode === "Characters") {
      return_me = (
        <Grid container spacing={0} direction="row">
          { obj.characters.map(char => {
            return (
              <Grid size={4} key={char._id}>
                { char.name }
              </Grid>
            );
          })}
        </Grid>
      ); 
    }
    return return_me;
  }  
  
  if (!fetched || loading) {
    const height = window.innerHeight - 64;
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else if (!api.online) {
    return (
      <>Joining only work while online.  Try reconnecting.</>
    );
  } else if (obj === null) {
    return <span>Something is wrong with the link you clicked</span>;
  } else if (api.user && obj.player_ids.includes(api.user._id)) {
    return <span>You're already in this campaign.</span>;
  } else if (api.user && obj.owner_id === api.user._id) {
    return <span>You own this campaign.</span>;
  } else { 
    console.log(obj);
    const tabs = ["Characters","Players"];
    return (
      <Grid container spacing={0} direction="row">
        <Grid size={12}>
          You've been invited to join a campaign by the name of {obj.name}.  
        </Grid>
        { api.user ? 
          <Grid size={12}>
            <ButtonBox 
              name="Accept Invitation"
              disabled={processing}
              onClick={ async () => {
                if (api.user) {
                  setProcessing(true);
                  const new_obj = obj;
                  if (invite && new_obj.invites.includes(invite)) {
                    new_obj.invites = new_obj.invites.filter(o => o !== invite);
                  }
                  await api.updateObject("campaign", new_obj);
                  const c_player = new CampaignPlayer();
                  c_player.campaign_id = new_obj._id;
                  c_player.player_id = api.user._id;
                  await api.upsertObject("campaign_player", c_player);
                  api.user.c_players.push(c_player);
                  api.user.playing_campaigns.push(new_obj);
                  c_player.player = api.user;
                  c_player.campaign = new_obj;
                  if (new_obj.c_players) {
                    new_obj.c_players.players.push(c_player);
                  }
                  api.updateUserSBs();
                  if (!api.user.all_users.some(o => o._id === new_obj.owner_id) && new_obj.owner) {
                    api.user.all_users.push(new_obj.owner);
                  }
                  for (const user of new_obj.players) {
                    if (!api.user.all_users.some(o => o._id === user._id)) {
                      api.user.all_users.push(user);
                    }
                  }
                  setProcessing(false);
                  setNavigateTo(`/campaign/${new_obj._id}`);
                }
              }}
            />
          </Grid>
          :
          <Grid size={12}>
            You need to log in first to be able to join.
          </Grid>
        }
        <Grid size={12}>
          <CenteredMenu
            options={tabs}
            selected={mode}
            onSelect={setMode}
          />
        </Grid>
        <Grid size={12}>
          { render_tab() }
        </Grid>
      </Grid>
    );
  }
}
